import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        warningContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            width: '100%',
            maxWidth: '460px',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3),
            padding: theme.spacing(4, 3),
            borderRadius: '16px',
            backgroundColor: 'rgba(237, 108, 2, 0.04)',
            border: '1px solid rgba(237, 108, 2, 0.22)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.02)',
        },
        warningIconBadge: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            backgroundColor: 'rgba(237, 108, 2, 0.12)',
            marginBottom: theme.spacing(2),
            boxShadow: '0 0 0 8px rgba(237, 108, 2, 0.05)',
        },
        warningIcon: {
            fontSize: '36px',
            color: '#ed6c02',
        },
        warningTitle: {
            fontSize: '1.125rem',
            fontWeight: 600,
            color: theme.palette.text.primary,
            marginBottom: theme.spacing(1),
            lineHeight: 1.3,
        },
        warningMessage: {
            fontSize: '0.9375rem',
            lineHeight: 1.6,
            color: theme.palette.text.secondary,
            maxWidth: '380px',
        },
        warningButton: {
            marginTop: theme.spacing(3),
        },
    })
);
